import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthRoutesService {
  // Lista de patrones de URL que NO requieren token
  private publicPatterns: string[] = [
    '/type_establishments',
    '/auth/login',
    '/auth/register',
    '/auth/refresh',
    '/establishments',
    '/',
    '/products-establishment'
    // Añadir aquí otros patrones públicos
  ];

  /**
   * Verifica si una URL es pública (no requiere autenticación)
   * @param url URL a verificar
   * @returns true si la URL es pública, false si requiere autenticación
   */
  isPublicUrl(url: string): boolean {
    // Extraer la ruta base sin parámetros de consulta
    const baseUrl = url.split('?')[0];

    // Verificar si la URL es exactamente una ruta pública o comienza con un patrón público seguido de /
    return this.publicPatterns.some(pattern =>
      baseUrl === pattern ||
      baseUrl.startsWith(pattern + '/') ||
      // Para manejar rutas con parámetros como /products-establishment/123
      (pattern.endsWith('establishment') && baseUrl.startsWith('/products-establishment/'))
    );
  }

  /**
   * Añade un nuevo patrón a la lista de URLs públicas
   * @param pattern Patrón de URL a añadir
   */
  addPublicPattern(pattern: string): void {
    if (!this.publicPatterns.includes(pattern)) {
      this.publicPatterns.push(pattern);
    }
  }
}
